// extracted by mini-css-extract-plugin
export default {"DialogBody":"InputDialog_DialogBody__DoJWP"};